<template>
  <div class="ner-list-wrapper">
    <div class="card h-fill w-fill">
      <nav-bar :options="pageOptions" v-model="currentPage"></nav-bar>
      <div class="user-define-extractor" v-if="currentPage==='userDefineExtractor'">
        <div class="no-data-wrapper" v-if="customParserList.length===0">
          <h1 class="title">{{$t('ner.extractor.no_define_extractor')}}</h1>
          <p class="desc">{{$t('ner.extractor.no_define_extractor_desc')}}</p>
          <text-button v-if="canCreate" button-type="fill" @click="popEditCustomParserDlg()">
            {{$t('ner.extractor.add_user_define')}}</text-button>
        </div>
        <div class="has-data-wrapper" v-else>
          <text-button v-if="canCreate" button-type="fill" class="add-parser-btn" @click="popEditCustomParserDlg()">
            {{$t('ner.extractor.add_user_define')}}</text-button>
          <div class="parser-list">
            <div v-for="(item, index) in customParserList" :key="index"
            class="custom-parser-item" @click="handleCheckParserDetail(item.parserId)">
              <div class="info-box">
                <p class="name">{{item.name}}</p>
                <p class="publish-time">
                  {{item.flag===1?$t('ner.extractor.published'):$t('ner.extractor.not_publish')}}
                </p>
              </div>
              <el-popover placement="top" width="263" v-model="item.isDeleting">
                <p style="text-align: center; margin:5px 0px;"
                v-html="item.usedNum>0?$t('ner.extractor.cannot_delete'):$t('ner.extractor.delete_confirm')"></p>
                <div v-if="!item.usedNum" style="text-align: right; margin-top: 10px">
                  <button class="btn-small btn-white-gray" @click="handleDeleteParser(item)">
                    {{$t('ner.extractor.confirm_delete')}}</button>
                  <button class="btn-small btn-white-gray" @click="item.isDeleting = false">
                  {{$t('general.cancel')}}</button>
                </div>
                <div class="operate-box" v-if="canDelete" slot="reference" @click.stop.prevent="handleClickDeleteParser(index)">
                  <span class="delete-btn">{{$t('general.delete')}}</span>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="general-extractor" v-else-if="currentPage==='generalExtractor'">
        <div class="no-data-wrapper" v-if="generalParserList.length===0">
          <h1 class="title">{{$t('ner.extractor.no_general_extractor')}}</h1>
        </div>
        <div class="has-data-wrapper" v-else>
          <div class="parser-list">
            <div v-for="(item, index) in generalParserList" :key="index" class="general-parser-item">
              <div class="info-box">
                <p class="name">{{item.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wordbank-wrapper" v-else-if="currentPage==='wordbank'">
        <div class="op-bar">
          <input class="file-chooser" type="file" ref="fileChooser"
          accept=".xlsx" @change="validateFileSize"/>
          <text-button v-if="canImport" button-type="fill" class="upload-wb-button" @click="openFileChooser">
            {{$t('ner.wb.upload_wb')}}</text-button>
          <span v-if="canImport" class="download-wb-template" @click="handleDownloadWBTempl">
            {{$t('ner.wb.download_wb_template')}}</span>
          <span v-show="isUploadingWB">{{$t('ner.wb.uploading_wb')}}</span>
        </div>
        <div class="no-wb-wrapper" v-if="wordBankList.length === 0">
          <p class="no-wb-title">{{$t('ner.wb.no_wb')}}</p>
          <p class="no-wb-desc">{{$t('ner.wb.no_wb_desc')}}</p>
        </div>
        <div class="has-wb-wrapper" v-else>
          <div class="wb-item-wrapper" v-for="(wb, index) in wordBankList" :key="wb.id">
            <div class="wb-item">
              <span class="wb-name">{{wb.name}}</span>
              <span class="wb-view-btn" @click="handleViewWB(wb)">{{$t('ner.wb.view')}}</span>
              <!-- <el-popover placement="top" width="263" v-model="wb.isDeleting">
                <p style="text-align: center; margin-top:5px;" v-html="$t('ner.extractor.delete_wb_alert')"></p>
                <div style="text-align: right; margin-top: 10px">
                  <button class="btn-small btn-white-gray" @click="handleDeleteWb(index, wb)">
                    {{$t('ner.extractor.confirm_delete')}}</button>
                  <button class="btn-small btn-white-gray" @click.prevent.stop="cancelDeleteWB(wb)">
                  {{$t('general.cancel')}}</button>
                </div>
                <span v-if="canDelete" class="delete-icon" slot="reference">{{$t('ner.wb.delete')}}</span>
              </el-popover> -->
              <el-popover placement="top" width="263">
                <p style="text-align: center; margin:5px 0px;" v-html="$t('ner.extractor.delete_wb_alert')"></p>
                <div style="text-align: right; margin-top: 10px">
                  <button class="btn-small btn-white-gray" @click="handleDeleteWb(index, wb)">
                    {{$t('ner.extractor.confirm_delete')}}</button>
                  <button class="btn-small btn-white-gray" @click.stop.prevent="handleCancelDeleteWB(index)">
                  {{$t('general.cancel')}}</button>
                </div>
                <!-- <div :ref="'deleteWBBtn'+index" class="operate-box" v-if="canDelete" slot="reference" @click.stop.prevent="handleClickDeleteWB(index)">
                  <span class="delete-btn">{{$t('general.delete')}}</span>
                </div> -->
                <span :ref="'deleteWBBtn'+index" v-if="canDelete"
                class="delete-icon" slot="reference">{{$t('ner.wb.delete')}}</span>
              </el-popover>
            </div>
          </div>     
        </div>
      </div>
    </div>
    <word-bank-detail v-model="isCheckingWBDetail" :wb="currentWB" v-if="currentWB"></word-bank-detail>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ParserEditor from './_components/ParserEditor';
import ErrorMessage from './_components/ErrorMessage';
import WordBankDetail from './_components/WordBankDetail';
import api from './_api/ner';

export default {
  path: 'ner-extractor',
  privCode: 'ner_factory',
  displayNameKey: 'ner_extractor',
  icon: 'white_folder',
  api,
  components: {
    ParserEditor,
    ErrorMessage,
    WordBankDetail,
  },
  data() {
    return {
      pageOptions: {
        userDefineExtractor: this.$t('ner.extractor.user_define'),
        // generalExtractor: this.$t('ner.extractor.general'),
        wordbank: this.$t('ner.wb.wb'),
      },
      // currentPage: 'userDefineExtractor',
      currentPage: 'userDefineExtractor',
      customParserList: [],
      generalParserList: [],
      wordBankList: [],
      parserObj: {},
      file: undefined,
      isCheckingWBDetail: false,
      currentWB: null,
      isUploadingWB: false,
    };
  },
  watch: {
    currentPage() {
      for (let i = 0; i < this.customParserList.length; i += 1) {
        this.customParserList[i].isDeleting = false;
      }
      for (let j = 0; j < this.wordBankList.length; j += 1) {
        this.wordBankList[j].isDeleting = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      'robotID',
      'robotName',
    ]),
    existParserNames() {
      if (this.customParserList.length === 0) {
        return [];
      }
      const names = [];
      this.customParserList.forEach((parser) => {
        names.push(parser.name);
      });
      return names;
    },
    canCreate() {
      return this.$hasRight('edit');
    },
    canDelete() {
      return this.$hasRight('edit');
    },
    canEdit() {
      return this.$hasRight('edit');
    },
    canExport() {
      return this.$hasRight('export');
    },
    canImport() {
      return this.$hasRight('edit');
    },
  },
  created() {
    this.getCustomParserList();
    this.getGeneralParserList();
    this.getWordBankList();
  },
  mounted() {
    this.$api.registerNERUser(this.robotID, this.robotName).then(() => {
      console.log('ner user registered');
    }).catch((e) => {
      this.$notifyFail(e.message || e.response.data.message);
    });
  },
  methods: {
    openFileChooser() {
      this.$refs.fileChooser.click();
    },
    // 导入词库文件
    uploadWBFile() {
      const that = this;
      this.isUploadingWB = true;
      that.$api.uploadWordBank(this.file, this.robotID)
        .then((res) => {
          if (res.status === 'success') {
            that.$notify({ text: that.$t('ner.extractor.upload_wb_success') });
            this.getWordBankList();
          }
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (err.response.data.message) {
              that.$pop({
                title: that.$t('wordbank.result.fail'),
                data: {
                  errorMessage: err.response.data.message,
                },
                component: ErrorMessage,
                buttons: ['ok'],
              });
            } else {
              that.$notifyFail(that.$t('wordbank.error.import_format_invalid'));
            }
          } else {
            that.$notifyFail(that.$t('wordbank.result.fail'));
          }
        })
        .finally(() => {
          that.$refs.fileChooser.value = '';
          this.isUploadingWB = false;
        });
    },
    validateFileSize() {
      const fileSizeLimit = 2 * 1024 * 1024;
      const theFile = this.$refs.fileChooser.files[0];
      let fileValid = false;
      if (!theFile) {
        fileValid = false;
        this.$notifyFail(this.$t('wordbank.upload_file_undefined'));
      } else if (theFile.size <= 0 || theFile.size > fileSizeLimit) {
        fileValid = false;
        this.$notifyFail(this.$t('wordbank.upload_file_size_error'));
      } else if (!/(?:.xlsx|.xls)$/.test(theFile.name)) {
        fileValid = false;
        this.$notifyFail(this.$t('general.batch_upload.only_xlsx_xls'));
      } else {
        fileValid = true;
        this.file = theFile;
      }
      if (fileValid) {
        this.uploadWBFile();
      } else {
        this.$refs.fileChooser.value = '';
      }
    },
    // 下载词库模板
    handleDownloadWBTempl() {
      this.$api.downloadNERWordBankTemplate();
    },
    handleViewWB(wb) {
      this.currentWB = wb;
      this.isCheckingWBDetail = true;
    },
    cancelDeleteWB(wb) {
      wb.isDeleting = false;
      this.wordBankList = Array.concat([], this.wordBankList);
    },
    // 删除词库
    handleDeleteWb(index, wb) {
      const that = this;
      this.$api.deleteWordBank(this.robotID, wb.id).then((res) => {
        if (res.status === 'success') {
          this.$notify({
            text: that.$t('ner.wb.delete_success'),
          });
          that.getWordBankList();
        } else {
          this.$notifyWarn(res.message);
        }
      }).catch((err) => {
        this.$notifyFail(err.response.data.message || err.message);
      }).finally(() => {
        wb.isDeleting = false;
      });
    },
    // 获取自定义抽取器列表
    getCustomParserList() {
      this.$startPageLoading();
      this.$api.getCustomParserList(this.robotID).then((list) => {
        this.customParserList = list;
        this.$endPageLoading();
      }).catch((e) => {
        this.$notifyFail(e.response.data.message);
      });
    },
    // 获取通用抽取器列表
    getGeneralParserList() {
      this.$api.getGeneralParserList(this.robotID).then((list) => {
        this.generalParserList = list;
      }).catch((e) => {
        this.$notifyFail(e.response.data.message);
      });
    },
    // 获取NER词库列表
    getWordBankList() {
      this.$api.getWordBankList(this.robotID).then((list) => {
        this.wordBankList = list;
      }).catch((e) => {
        this.$notifyFail(e.response.data.message);
      });
    },
    // 查看抽取器详情 + 编辑抽取器
    handleCheckParserDetail(parserId) {
      this.$api.getCustomParser(this.robotID, parserId).then((detail) => {
        const parserObj = detail.data;
        parserObj.parserId = parserId;
        this.popEditCustomParserDlg(parserObj);
      }).catch((e) => {
        this.$notifyFail(e.response.data.message);
      });
    },
    // 打开自定义抽取器编辑框
    popEditCustomParserDlg(parserObj) {
      if (parserObj && parserObj.parserId) {
        this.parserObj = parserObj;
      } else {
        this.parserObj = {
          parserId: '',
          parserName: '',
          slots: [
            { name: '', extractor: { baseParsers: [], dicts: [], rules: [] } },
          ],
          corpus: [],
        };
      }
      const that = this;
      const twoButtons = [{
        msg: this.$t('ner.extractor.save_and_publish'),
        event: 'validate',
        type: 'fill',
        callback: () => {
          this.parserObj.onlySave = false;
        },
      }, {
        msg: this.$t('ner.extractor.only_save'),
        event: 'validate',
        callback: () => {
          this.parserObj.onlySave = true;
        },
      }];
      const oneButton = [{
        msg: this.$t('ner.extractor.save_and_publish'),
        event: 'validate',
        type: 'fill',
        callback: () => {
          this.parserObj.onlySave = false;
        },
      }];
      const customButtons = this.parserObj.used_num > 0 ? oneButton : twoButtons;
      const option = {
        title: this.parserObj.parserName || this.$t('ner.extractor.add_user_define'),
        component: ParserEditor,
        data: {
          canEdit: this.canEdit,
          canExport: this.canExport,
          existParserNames: this.existParserNames,
          extractor: this.parserObj,
          wordBankList: this.wordBankList,
          generalParserList: this.generalParserList,
          readonly: false,
        },
        validate: true,
        cancelValidate: true,
        buttons: ['cancel'],
        custom_button: customButtons,
        callback: {
          ok() {
            // debugger;
            if (that.parserObj.onlySave) {
              // 仅保存
              that.handleSaveCustomParser(that.parserObj, false);
            } else {
              // 保存且发布
              that.handleSaveCustomParser(that.parserObj, true);
            }
          },
        },
      };
      this.$pop(option);
    },
    handleClickDeleteParser(index) {
      for (let i = 0; i < this.customParserList.length; i += 1) {
        if (i !== index) {
          this.customParserList[i].isDeleting = false;
        }
      }
    },
    handleCancelDeleteWB(index) {
      // debugger;
      this.$refs[`deleteWBBtn${index}`][0].click();
    },
    handleDeleteParser(parser) {
      if (!parser.parserId) {
        return;
      }
      this.$api.deleteCustomParser(this.robotID, parser.parserId, parser.name).then((res) => {
        if (res.status === 'success') {
          this.$notify({ text: '删除成功' });
          this.getCustomParserList();
        }
      }).catch((e) => {
        this.$notifyFail(e.response.data.message);
      });
    },
    handleSaveCustomParser(parserObj, flagTrain) {
      const that = this;
      delete parserObj.onlySave;
      if (parserObj.created_time) {
        // [更新|更新且训练]抽取器
        this.$api.updateCustomParser(this.robotID, parserObj, flagTrain).then((res) => {
          if (res.status === 'success') {
            const message = flagTrain ? that.$t('ner.extractor.save_train_success') : that.$t('ner.extractor.save_success');
            this.$notify({ text: message });
            this.getCustomParserList();
          }
        }).catch((e) => {
          const message = flagTrain ? that.$t('ner.extractor.save_train_fail') : that.$t('ner.extractor.save_fail');
          this.$notifyFail(e.response.data.message || message);
        });
      } else {
        // [创建|创建且训练]抽取器
        this.$api.createCustomParser(this.robotID, parserObj, flagTrain).then((res) => {
          if (res.status === 'success') {
            const msg = flagTrain ? that.$t('ner.extractor.save_train_success') : that.$t('ner.extractor.save_success');
            this.$notify({ text: msg });
            this.getCustomParserList();
          }
        }).catch((e) => {
          const message = flagTrain ? that.$t('ner.extractor.save_train_fail') : that.$t('ner.extractor.save_fail');
          this.$notifyFail(e.response.data.message || message);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ner-list-wrapper{
  .user-define-extractor, .general-extractor, .wordbank-wrapper{
    width: 100%;
    height: calc(100% - 60px);
    padding: 20px;
    overflow: auto;
    .no-data-wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
      .title{
        color: $color-font-active;
        margin-bottom: 10px;
        @include font-16px();
      }
      .desc{
        color: $color-font-normal;
        margin-bottom: 30px;
        @include font-14px();
      }
    }
    .has-data-wrapper{
      .add-parser-btn{
        margin-bottom: 20px;
      }
      .parser-list{
        width: 100%;
        min-width: 740px;
        .custom-parser-item{
          margin: 0px 20px 20px 0px;
          width: calc((100% - 40px) / 3);
          float: left;
          border: 1px solid $color-borderline-disabled;
          padding: 10px 20px;
          border-radius: 2px;
          cursor: pointer;
          &:nth-child(3n+3) {
            margin-right: 0px;
          }
          &:hover{
            .info-box{
              .name{
                color: $color-primary;
              }
            }
          }
          .info-box{
            display: inline-block;
            width: calc(100% - 50px);
            .name{
              overflow: hidden;
              color: $color-font-active;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              @include font-14px();
            }
            .publish-time{
              margin-top: 5px;
              color: $color-font-normal;
              @include font-12px();
            }
          }
          .operate-box{
            display: inline-block;
            float: right;
            line-height: 43px;
            vertical-align: top;
            .delete-btn{
              color: #F25C62;
              @include font-14px();
              cursor: pointer;
            }
          }
        }
        .general-parser-item{
          float: left;
          margin: 0px 20px 20px 0px;
          padding: 22px 20px;
          width: calc((100% - 60px) / 4);
          border: 1px solid $color-borderline-disabled;
          border-radius: 2px;
          cursor: pointer;
          overflow: hidden;
          color: $color-font-active;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          @include font-14px();
          &:hover{
            color: $color-primary;
          }
          &:nth-child(4n+4) {
            margin-right: 0px;
          }
        }
      }
    }
  }
  .wordbank-wrapper{
    .op-bar{
      .file-chooser{
        display: none;
      }
      .upload-wb-button{
        width: 87px;
        margin-bottom: 20px;
      }
      .download-wb-template{
        color: $app-active-color;
        @include font-12px();
        cursor: pointer;
        margin: 0px 10px 20px 10px;
      }
    }
    .no-wb-wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 400px;
      .no-wb-title{
        color: $color-font-active;
        @include font-16px();
      }
      .no-wb-desc{
        color: $color-font-normal;
        @include font-14px();
        margin-top: 10px;
      }
    }
    .has-wb-wrapper{
      overflow-y: auto;
      // display: inline-block;
      width: 100%;
      .wb-item-wrapper{
        display: inline-block;
        width: calc((100% - 40px) / 3);
        margin: 0px 20px 20px 0px;
        height: 46px;
        border-radius: 2px;
        border: 1px solid $color-borderline-disabled;
        &:nth-child(3n+3) {
          margin-right: 0px;
        }
      }
      .wb-item{
        width: 100%;
        height: 100%;
        padding: 0px 20px;
        display: flex;
        align-items: center;
        justify-content: center; 
        .wb-name{
          display: inline-block;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: $color-font-active;
          @include font-14px();
        }
        .wb-view-btn{
          color: $color-primary;
          cursor: pointer;
          @include font-14px();
        }
        .delete-icon{
          margin-left: 10px;
          color: #F25C62;
          cursor: pointer;
          @include font-14px();
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/NER/NERExtractorList.vue